import { render, staticRenderFns } from "./BaseBuilderWrapper.vue?vue&type=template&id=5dda0d98&"
import script from "./BaseBuilderWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseBuilderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dda0d98')) {
      api.createRecord('5dda0d98', component.options)
    } else {
      api.reload('5dda0d98', component.options)
    }
    module.hot.accept("./BaseBuilderWrapper.vue?vue&type=template&id=5dda0d98&", function () {
      api.rerender('5dda0d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/wrapper/BaseBuilderWrapper.vue"
export default component.exports